module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form'
    ],

    config: {
        resourceConnected: false
    },

    methods: {
        dataDealer: function(){
            if(this.model.tableResourceData){
                this.resourceData = ((this.model.tableResourceData || {}).meta || {}).projectData || {}
            }
        },

        onChange: function(isRelationChange, changeDone, fieldData){
            if(fieldData.fieldValue !== null && (fieldData.fieldCode === 'startTS' || fieldData.fieldCode === 'endTS')){
                this.triggerFind('setAllTimeRecordsField', fieldData, 'templates_crew_timeRecordings_table_table')
                this.fieldToModel(fieldData.fieldCode, null)
                this.refresh(false)
            }
        }
    },

    handlers: [{
        name: 'refreshResources',
        componentClass: 'templates_crew_timeRecordings_table_table',
        handle: function(callerComponent){
            this.model.tableResourceData = callerComponent.resourceData
            if(this.config.isReady){
                this.refresh(false)
            }
        }
    }]
}